var map = {
	"./app-store-black.svg": 57975,
	"./app-store.png": 65058,
	"./boots-logo.svg": 74241,
	"./bottom-cta/shape-rectangle.svg": 14991,
	"./cabinet/doctor-avatar-icon.svg": 76334,
	"./cabinet/kit-icon.svg": 17690,
	"./cabinet/phone-check-sign-icon.svg": 29302,
	"./cabinet/red-dress-bladder-pain@2x-min.png": 52294,
	"./female-seated-toilet@2x-min.jpg": 89428,
	"./flags/ie.svg": 12809,
	"./flags/uk.svg": 95307,
	"./footer/medicspot-certification-logo.jpg": 16663,
	"./goodbye/goodbye.svg": 91137,
	"./google-play-black.svg": 62743,
	"./google-play.png": 6191,
	"./healthy-logo.svg": 81353,
	"./homepage/customer-review-claudia-min.png": 44614,
	"./homepage/customer-review-claudia@2x-min.png": 63718,
	"./homepage/customer-review-magdalena-min.png": 80052,
	"./homepage/customer-review-magdalena@2x-min.png": 28997,
	"./homepage/customer-review-sarah1-min.png": 21448,
	"./homepage/customer-review-sarah1@2x-min.png": 55157,
	"./homepage/customer-review-sarah2-min.png": 43863,
	"./homepage/customer-review-sarah2@2x-min.png": 16338,
	"./homepage/hero-image.png": 38580,
	"./homepage/kit-phone-diputi@2x-min.png": 29497,
	"./homepage/kit-phone-velieve@2x-min.png": 58704,
	"./homepage/testimonial-image-min.png": 71086,
	"./homepage/ux-design-awards-gold-2021.png": 73519,
	"./info-center/play-circle-icon.svg": 75058,
	"./info-center/play-icon.svg": 30318,
	"./info-center/thumbnail-placeholder.svg": 82082,
	"./landing-page/landing-hero-desktop.png": 7423,
	"./landing-page/landing-hero-mobile.png": 41010,
	"./landing-page/testimonial-container-1.svg": 43101,
	"./landing-page/testimonial-container-2.svg": 30325,
	"./landing-page/testimonial-container-3.svg": 70005,
	"./nhs.svg": 6682,
	"./og-image-diputi-min.jpg": 7597,
	"./og-image-velieve-min.jpg": 75530,
	"./powered-by-google-on-white-hdpi.png": 63261,
	"./product/about-the-product-kit-diputi@2x-min.png": 25421,
	"./product/about-the-product-kit-velieve@2x-min.png": 20675,
	"./product/app-intro-device-diputi@2x-min.png": 43753,
	"./product/app-intro-device-velieve@2x-min.png": 54269,
	"./product/app-store-icon.png": 2524,
	"./product/device-color-board@2x-min.png": 84527,
	"./product/google-play-icon.png": 30023,
	"./product/testimonial-container-1.svg": 15243,
	"./product/testimonial-container-2.svg": 51963,
	"./product/testimonial-container-3.svg": 66147,
	"./send-off/send-off.svg": 93238,
	"./shared/quote-sign-close.svg": 61236,
	"./shared/quote-sign-open.svg": 25626,
	"./store-locator/bigMarker.svg": 45248,
	"./store-locator/marker.svg": 85043,
	"./store-locator/miniMarker.svg": 50794,
	"./store-locator/userLocation.svg": 76450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50767;